import { createFileRoute } from '@tanstack/react-router';
import { SettingsPanel } from '@/components/Settings/SettingsPanel';

export const Route = createFileRoute('/settings')({
  component: SettingsPanel,
});
